<template>
    <div>
        <a-page-header class="page-header icon" @back="() => null" :sub-title="sub_title">
            <svg class="icon" aria-hidden="true" slot="backIcon" @click="$router.replace('/trademark')">
                <use xlink:href="#icon-shangbiaoguanli" />
            </svg>

            <template #title>商标管理<a-icon class="separator" type="right" /> </template>

            <template slot="extra">
                <div class="extra-shortcut">
                    <a-icon type="plus-circle" class="pointer" @click="on_add_shortcut" />
                </div>
            </template>
        </a-page-header>

        <div class="framework-container">
            <div
                class="framework-side"
                :class="[visible_sidebar ? 'visible' : '', small_screen ? 'ss' : '', visible_sidebar ? 'tg-on' : 'tg-off']"
            >
                <div class="module-title">
                    商标管理
                </div>

                <a-menu class="menu" mode="inline" v-model="selected_menu" :inlineIndent="16">
                    <!-- <a-menu-item key="trademark" @click="on_jump('/trademark')" v-if="permissible.indexOf('data.member_distribute') > -1"
                        >总览</a-menu-item
                    > -->

                    <a-menu-item key="whole" @click="on_jump('/trademark/whole')" v-if="permissible.indexOf('trademark') > -1"
                        >商标列表</a-menu-item
                    >

                    <a-menu-item
                        key="supplier"
                        @click="on_jump('/trademark/supplier')"
                        v-if="permissible.indexOf('trademark.supplier') > -1"
                        >商标供应商</a-menu-item
                    >

                    <a-menu-item key="enquiry" @click="on_jump('/trademark/enquiry')">商标询价</a-menu-item>
                    <a-menu-item key="tags" @click="on_jump('/trademark/tags')" v-if="permissible.indexOf('trademark.tags') > -1"
                        >商标标签</a-menu-item
                    >
                </a-menu>
            </div>

            <div class="framework-body" :class="[visible_sidebar ? 'tg-on' : 'tg-off', small_screen ? 'ss' : '']">
                <router-view />
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                sub_title: "商标管理",
                loading_tag: false,
                menu: [
                    { name: "总览", value: "data" },
                    { name: "商标列表", value: "whole" },
                    { name: "商标供应商", value: "supplier" },
                    { name: "店铺标签", value: "tags" },
                ],
            };
        },
        created() {
            this.where();

            this.$store.commit("change_state", {
                name: "sidebar_key",
                value: "trademark",
            });
        },
        watch: {
            $route() {
                this.where();
            },
        },
        methods: {
            where() {
                let current = window.location.pathname.split("/").pop();
                this.selected_menu = [current];

                this.menu.filter((v) => {
                    if (current === v.value) {
                        this.sub_title = v.name;
                    }
                });
            },
            on_jump(v) {
                return this.$router.push(`${v}`);
            },
        },
    };
</script>
<style lang="less" scoped>
    .framework-container {
        .framework-side {
            .toolbar {
                .item {
                    margin-left: auto;
                    margin-right: auto;
                    text-align: center;
                    cursor: pointer;
                    .text {
                        font-size: 12px;
                    }
                }
            }
        }
        .framework-body {
            position: absolute;
            left: 200px;
            right: 0;
            bottom: 0;
            top: 0;
        }

        .badget-color {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            display: inline-block;
            margin-right: 8px;
        }
    }
</style>
